const athleticoPR = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 25/26 - Uniforme 1",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2025",
      "atletico 2025",
      "atlético 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/25-26-01/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/25-26-01/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/25-26-01/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/25-26-01/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/25-26-01/cap4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 25/26 - Uniforme 3",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2025",
      "atletico 2025",
      "atlético 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/25-26-03/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/25-26-03/cap1.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 24/25 - Uniforme 1",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2024",
      "atletico 2024",
      "atlético 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/24-25-01/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-01/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-01/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-01/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-01/cap4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 24/25 - Uniforme 3",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2024",
      "atletico 2024",
      "atlético 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/24-25-03/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-03/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-03/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-03/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-03/cap4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 24/25 - Uniforme de Treino (Laranja)",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2024",
      "atletico 2024",
      "atlético 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/24-25-04/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-04/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-04/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-04/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-04/cap4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 17/18 - Uniforme 1 Retrô",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2018",
      "atletico 2018",
      "atlético 2018",
      "athletico retro",
      "atletico retro",
      "retro",
      "retro athletico",
      "retro atletico",
      "retro atlético",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/athleticopr/17-18-01/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/17-18-01/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/17-18-01/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/17-18-01/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/17-18-01/cap4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 24/25 - Uniforme de Treino (Cinza)",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2024",
      "atletico 2024",
      "atlético 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/24-25-04-cinza/cap0.jpeg",
      "/images/brasil/serie-a/athleticopr/24-25-04-cinza/cap1.jpeg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 24/25 - Pré Jogo",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2024",
      "atletico 2024",
      "atlético 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/24-25-05/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-05/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-05/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-05/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-05/cap4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 24/25 - Uniforme 1 (Feminina)",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2024",
      "atletico 2024",
      "atlético 2024",
      "athletico feminina",
      "atletico feminina",
      "atlético feminina",
      "athletico feminino",
      "atletico feminino",
      "atlético feminino",
      "feminina",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/24-25-01-f/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-01-f/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-01-f/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-01-f/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-01-f/cap4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 24/25 - Uniforme 3 (Feminina)",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2024",
      "atletico 2024",
      "atlético 2024",
      "athletico feminina",
      "atletico feminina",
      "atlético feminina",
      "athletico feminino",
      "atletico feminino",
      "atlético feminino",
      "feminina",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/24-25-03-f/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-03-f/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-03-f/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/24-25-03-f/cap3.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 23/24 - Uniforme 1",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2023",
      "atletico 2023",
      "atlético 2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/23-24-01/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-01/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-01/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-01/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-01/cap4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 23/24 - Uniforme 1 (Manga Comprida)",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2023",
      "atletico 2023",
      "atlético 2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/23-24-01-mc/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-01-mc/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-01-mc/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-01-mc/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-01-mc/cap4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 23/24 - Uniforme 2",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2023",
      "atletico 2023",
      "atlético 2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/23-24-02/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-02/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-02/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-02/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-02/cap4.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 23/24 - Uniforme 2 (Manga Comprida)",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2023",
      "atletico 2023",
      "atlético 2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/23-24-02-mc/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-02-mc/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-02-mc/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-02-mc/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-02-mc/cap4.jpg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 23/24 - Uniforme 3 (Manga Comprida)",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2023",
      "atletico 2023",
      "atlético 2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/23-24-03-mc/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-03-mc/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-03-mc/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-03-mc/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/23-24-03-mc/cap4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "athletico-paranaense",
    nome: "Athletico Paranaense 22/23 - Rosa (Feminina)",
    aliases: [
      "athletico paranaense",
      "atletico paranaense",
      "atlético paranaense",
      "athletico pr",
      "atletico pr",
      "atlético pr",
      "cap",
      "atlético",
      "atletico",
      "athletico",
      "furacão",
      "athletico 2023",
      "atletico 2023",
      "atlético 2023",
      "athletico feminina",
      "atletico feminina",
      "atlético feminina",
      "athletico feminino",
      "atletico feminino",
      "atlético feminino",
      "feminina",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/athleticopr/22-23-es-f/cap0.jpg",
      "/images/brasil/serie-a/athleticopr/22-23-es-f/cap1.jpg",
      "/images/brasil/serie-a/athleticopr/22-23-es-f/cap2.jpg",
      "/images/brasil/serie-a/athleticopr/22-23-es-f/cap3.jpg",
      "/images/brasil/serie-a/athleticopr/22-23-es-f/cap4.jpg",
    ],
  },
];

export default athleticoPR;
